<template>
  <div class="filial-with-search-select">
    <v-select
      :value="value"
      :items="filteredFilials"
      item-text="name"
      item-value="id"
      label="Филиал"
      hide-details="auto"
      class=""
      height="60"
      outlined
      flat
      solo
      :loading="loading"
      :disabled="disabled"
      :menu-props="{contentClass: 'filial-with-search-select-menu', maxHeight: '90vh'}"
      no-data-text="Ничего не найдено"
      return-object
      @change="setFilial"
      :rules="required ? [(v) => !!v || 'Обязательное поле'] : []"
    >
      <template v-slot:prepend-item>
        <v-list-item class="search-filial-with-search">
          <v-list-item-content>
            <v-text-field
              v-model="search"
              placeholder="Поиск..."
              filled
              dense
            >
              <template v-slot:append>
                <font-awesome-icon color="#FF9100" icon="search" />
              </template>
            </v-text-field>
          </v-list-item-content>
        </v-list-item>
      </template>

      <template v-slot:selection="{item}">
        <global-filial-select-item
          :item="item"
          :is-select-value="true"
        />
      </template>

      <template v-slot:item="{item, attrs}">
        <global-filial-select-item
          :item="item"
          :selected="attrs['aria-selected'] === 'true'" :width="'100%'"
          :is-list-item="true"
        />
      </template>
    </v-select>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import GlobalFilialSelectItem from '@/components/header/GlobalFilialSelectItem'

  export default {
    name: 'FilialSelectWithSearchField',
    components: { GlobalFilialSelectItem },
    data () {
      return {
        search: '',
      }
    },
    props: {
      value: {
        type: Object,
        default: () => {},
      },
      items: {
        type: Array,
        default: () => ([]),
      },
      loading: Boolean,
      disabled: Boolean,
      required: Boolean,
    },
    created () {

    },
    computed: {
      filteredFilials () {
        if (this.items.length) {
          return this.items.filter((filial) => {
            return filial.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          })
        } else {
          return this.value
        }
      },
    },
    methods: {
      setFilial (filial) {
        this.$emit('input', filial)
      },
    },

  }
</script>

<style lang="less">

.filial-with-search-select {

  &__icon {
    margin-right: 7px;
  }

  .v-select__selections {
    font-size: 14px;
  }

}

.filial-with-search-select-menu {
   box-shadow: 0px 4px 34px 0px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

.search-filial-with-search {
  margin-top: -8px;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 10;
  //border-bottom: 1px solid rgba(0, 0, 0, 0.12);

  .v-text-field {
    & > .v-input__control {
      & > .v-input__slot {
        &:after,
        &:before {
          display: none;
        }
      }
    }
  }
  .v-input {
    border-radius: 5px;
    input {
      font-size: 14px;
    }

    &.v-text-field--outlined.v-input--is-focused fieldset {
       border: 1px solid rgba(0,0,0, 0.7) !important;
    }

    &__append-inner {
      margin: auto 0 !important;
    }
  }
  .v-text-field__details {
    display: none;
  }
}
</style>
